import React from 'react'

import { SpookySkeleton } from '@offerzen/pinata-shame'

import SkeletonToolbar from '../SkeletonToolbar'

const SkeletonCompanyExperience = () => (
  <SpookySkeleton>
    <SkeletonToolbar />
  </SpookySkeleton>
)

export default SkeletonCompanyExperience
